import { render, staticRenderFns } from "./IntermediayList.vue?vue&type=template&id=5c6babae"
import script from "./IntermediayList.vue?vue&type=script&lang=js"
export * from "./IntermediayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports